const JOKER_BONUS_IDENTIFIERS = {
	JOKER_BONUS_WIN_NOTIFIER: Symbol('JOKER_BONUS_WIN_NOTIFIER'),
	JOKER_WIN_CONNECT_IDENTIFIER: Symbol('JOKER_WIN_CONNECT_IDENTIFIER'),
	JOKER_BONUS_CURRENCY_CONVERT: Symbol('JOKER_BONUS_CURRENCY_CONVERT'),
	JOKER_WIN_LEVEL_INFO_CONNECT_IDENTIFIER: Symbol(
		'JOKER_WIN_LEVEL_INFO_CONNECT_IDENTIFIER'
	),
	JOKER_BONUS_UNCLAIMED_TICKETS: Symbol('JOKER_BONUS_UNCLAIMED_TICKETS'),
	JOKER_BONUS_THEMES: Symbol('JOKER_BONUS_THEMES'),
	JOKER_BONUS_TRANSLATE_SERVICE: Symbol('JOKER_BONUS_TRANSLATE_SERVICE'),
	JOKER_WIN_BANNER_IDENTIFIER: Symbol('JOKER_WIN_BANNER_IDENTIFIER'),
}

export default JOKER_BONUS_IDENTIFIERS
